<div class="row mb-2">
  <div class="col">
    <div class="d-flex align-items-center">
      <h1 [innerHTML]="title"></h1>
      <app-button
        *ngIf="showGoBack"
        [buttonColor]="backButtonColor"
        [buttonText]="backButtonText"
        [buttonSize]="backButtonSize"
        class="ms-auto"
        (onClickedEvent)="onGoBackClicked()"
      ></app-button>
      <ng-content></ng-content>
    </div>
    <hr />
  </div>
</div>
